import type { ComponentProps, MouseEvent } from "react"
import cn from "@/v2-ui/utils/utils.cn"

export type ViewSheetResizeHandleProps = ComponentProps<"div"> & {
  sheetWidth: number
  onResizeStart(event: MouseEvent<HTMLDivElement>): void
  onResetWidth(): void
}

function ViewSheetResizeHandle(props: ViewSheetResizeHandleProps) {
  const {
    sheetWidth,
    onResizeStart,
    onResetWidth,
    className,
    style,
    ...divProps
  } = props

  return (
    <div
      className={cn("view-sheet-resize-handle", className)}
      {...divProps}
      onMouseDown={onResizeStart}
      onDoubleClick={onResetWidth}
      style={{ ...style, right: sheetWidth - 3 }}
    />
  )
}

export default ViewSheetResizeHandle
